export default class Workflow {

  constructor(
    IdWorkflow = null,
    Descricao = '',
    Status = 'A',
    QtFase
  ) {
    this.IdWorkflow = IdWorkflow;
    this.Descricao = Descricao;
    this.Status = Status;
    this.QtFase = QtFase;
  }
  
}